var lib_core = require("lib-core");

/**
 * @constructor
 */
var TrayAssetSearchTabStateMachine = function (root, model, parentName) {
    var self = this;
    this.root = root;

    this.model = model;
    this.parentName = parentName;

    var sortingKeyArchive = model.sorting();
    var sortingDirectionArchive = model.sorting_direction();

    lib_core.StateMachine.call(self, null, null, this.model.scope());

    this.sortingTransition = self.addTransition("idle","idle",
        function(cEvent){
            return (cEvent.type() == lib_core.GuiEvents.UI_TRAY_TAB_SORT &&
                cEvent.data('parentName') == self.parentName &&
                cEvent.data('tabName') == self.model.name());
        },
        function(cEvent){
            var sortingKey = cEvent.data('sortingKey');
            var sortingDir = cEvent.data('sortingDir');

            var isProp = cEvent.data('isProp'); 
            
            //if sortingDir is available use it directly (case: sort by drop down list)
            //if sortingDir not available toggle direction (case: sort by drop down arrow)
            if(!sortingDir) {
                sortingDir = (sortingKeyArchive == sortingKey && sortingDirectionArchive == 'desc') ? 'asc' : 'desc';
            }

            self.model.sorting_direction(sortingDir);
            self.model.sorting(sortingKey);
            self.model.sortIsProp(isProp)

            sortingKeyArchive = sortingKey;
            sortingDirectionArchive = sortingDir;

        }
    );

    this.searchTransition = self.addTransition("idle","idle",
        function(cEvent){
            return (cEvent.type() == lib_core.GuiEvents.UI_TRAY_TAB_SEARCH &&
                cEvent.data('parentName') == self.parentName &&
                cEvent.data('tabName') == self.model.name() );
        },
        function(cEvent){
            self.model.query(cEvent.data('val'));
        }
    );

    this.searchTransition = self.addTransition("idle","idle",
        function(cEvent){
            return (cEvent.type() == lib_core.GuiEvents.UI_TRAY_TAB_TEMPLATE_CHANGE &&
                cEvent.data('parentName') == self.parentName &&
                cEvent.data('tabName') == self.model.name() );
        },
        function(cEvent){
            self.model.alternative_template(self.model.template());
            self.model.template(cEvent.data('template'));
        }
    );


};
lib_core.inherit(TrayAssetSearchTabStateMachine, lib_core.StateMachine);

module.exports = TrayAssetSearchTabStateMachine;
